import React from "react";
import Layout from "components/Layout";
import SocialProfiles from "components/SocialProfiles";
import "styles/legal.css";

const ImpressumPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <p className="legal-kicker">Anbieterkennzeichnung</p>
          <h1>Impressum</h1>

          <p className="legal-meta">
            Angaben nach § 5 Digitale-Dienste-Gesetz (DDG) und weiteren
            gesetzlichen Informationspflichten. Stand: Juli 2026.
          </p>

          <div className="legal-toc" aria-label="Inhalt">
            <a href="#anbieter">Diensteanbieter</a>
            <a href="#register">Register und Steuern</a>
            <a href="#kontakt">Kontakt</a>
            <a href="#schlichtung">Schlichtung</a>
            <a href="#mstv">MStV</a>
          </div>

          <h2 id="anbieter">Diensteanbieter</h2>
          <dl className="legal-data-list">
            <div>
              <dt>Firma</dt>
              <dd>MediConsult GmbH</dd>
            </div>
            <div>
              <dt>Anschrift</dt>
              <dd>Cremon 11, 20457 Hamburg, Deutschland</dd>
            </div>
            <div>
              <dt>Vertreten durch</dt>
              <dd>Geschäftsführer Andreas Metz</dd>
            </div>
          </dl>

          <h2 id="kontakt">Kontakt</h2>
          <dl className="legal-data-list">
            <div>
              <dt>Telefon</dt>
              <dd>
                <a href="tel:+4940457543">+49 (0)40 457543</a>
              </dd>
            </div>
            <div>
              <dt>E-Mail</dt>
              <dd>
                <a href="mailto:info@dr-hoffmann-massage.de">
                  info@dr-hoffmann-massage.de
                </a>
              </dd>
            </div>
            <div>
              <dt>Website</dt>
              <dd>
                <a
                  href="https://dr-hoffmann-massage.de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  dr-hoffmann-massage.de
                </a>
              </dd>
            </div>
          </dl>

          <h2 id="register">Register und Steuern</h2>
          <dl className="legal-data-list">
            <div>
              <dt>Handelsregister</dt>
              <dd>HRB 176683</dd>
            </div>
            <div>
              <dt>Registergericht</dt>
              <dd>
                <span className="legal-todo">
                  Amtsgericht Hamburg
                </span>
              </dd>
            </div>
            <div>
              <dt>Umsatzsteuer-ID</dt>
              <dd>DE217241097</dd>
            </div>
          </dl>

          <h2 id="schlichtung">Verbraucherstreitbeilegung</h2>
          <p>
            Die MediConsult GmbH ist weder verpflichtet noch bereit, an einem
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
          <p>
            Hinweis nach § 36 Verbraucherstreitbeilegungsgesetz (VSBG):
            Verbraucherinnen und Verbraucher können sich über bestehende
            Möglichkeiten der außergerichtlichen Streitbeilegung informieren.
          </p>

          <h2 id="mstv">Verantwortlichkeit nach § 18 Abs. 2 MStV</h2>
          <p>
            Soweit auf dieser Website journalistisch-redaktionelle Inhalte im
            Sinne des Medienstaatsvertrags angeboten werden, ist verantwortlich:
          </p>
          <p>
            Andreas Metz, MediConsult GmbH, Cremon 11, 20457 Hamburg,
            Deutschland.
          </p>

          <h2>Zulassungs- und berufsrechtliche Angaben</h2>
          <p>
            Für die hier beschriebenen Wellness- und Massageangebote ist nach
            derzeitiger interner Prüfung keine besondere behördliche Zulassung
            und keine Kammerzugehörigkeit als reglementierter Beruf hinterlegt.
            <span className="legal-todo">
              {" "}
            </span>
          </p>

          <h2>Social Media und andere Onlinepräsenzen</h2>
          <p>Dieses Impressum gilt auch für die folgenden Onlineprofile:</p>
          <SocialProfiles
            className="legal-social-list"
            iconClassName="legal-social-icon"
          />

          <h2>Hinweis zu Inhalten und Links</h2>
          <p>
            Eigene Inhalte auf dieser Website werden mit angemessener Sorgfalt
            erstellt. Verlinkte externe Inhalte liegen außerhalb unseres
            unmittelbaren Einflussbereichs; für sie ist der jeweilige Anbieter
            verantwortlich.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default ImpressumPage;
